import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AccountOption } from 'src/app/pages/account-register/models/account-option.interface';
import { State, selectAccountFeatureKey } from './select-account.reducer';

const selectAccountFeatureSelector = createFeatureSelector<State>(selectAccountFeatureKey);

export const getSelectedAccountName = createSelector(selectAccountFeatureSelector, (state) => {
   return state.accountName;
});

export const getSelectedAccountShortName = createSelector(selectAccountFeatureSelector, (state) => {
   return state.accountShortName;
});

export const getSelectedAccountId = createSelector(selectAccountFeatureSelector, (state) => {
   return state.accountId;
});

export const getSelectedAccount = createSelector(selectAccountFeatureSelector, (state) => {
   return { accountId: state.accountId, name: state.accountName } as AccountOption;
});

export const getSelectedAccountCallState = createSelector(selectAccountFeatureSelector, (state) => {
   return state.accountCallState;
});

export const getIsOnSystemPage = createSelector(selectAccountFeatureSelector, (state) => {
   return state.isOnSystemPage;
});

export const getSelectedAccountTimeZone = createSelector(selectAccountFeatureSelector, (state) => {
   return state.timeZoneId;
});
